module.exports = __webpack_public_path__ + "img/bg.28d18f81.jpg";